<button dsButton class="fs-topbar-info__tooltip-button"
        [dsTooltip]="fsTooltip"
        [dsTooltipPlacement]='["bottom-left"]'
        >
  <idh-svg [height]="28" [width]="28" [mobileHeight]="22" [mobileWidth]="22" src="./assets/images/help.svg" />
</button>

<ng-template #fsTooltip>
  <ds-tooltip [style.width.px]="270" [style.min-width.px]="270" [variant]="'light'" >
    <div class="help-container">

      <div class="ds-tooltip__header">
        <h4 class="help-container__header">{{ key() + '.header' | translate }}</h4>
      </div>
      <h6 class="help-container__subheader">{{  key() + '.faqHeader' | translate }}</h6>

      <button class="help-container__button" dsButton
              [variant]="'tertiary'"
              [full]="true"
              [size]="'m'"
              (click)="openLink(links.faqLink)">
        <idh-icon class="ds-button__icon-start"
                 [name]="'fs-question'"
                 [variant]="'primary'"
                 [size]="'m'"></idh-icon>
        {{  key() + '.faqBtn' | translate }}
      </button>

      <p class="help-container__content">
        {{  key() + '.supportHeader' | translate }}
      </p>

      <button class="help-container__button" dsButton
              [variant]="'tertiary'"
              [size]="'s'"
              (click)="openLink(links.supportLink)">
        <idh-icon class="ds-button__icon-start"
                 [name]="'fs-email'"
                 [stroke]="true"
                 [size]="'s'"></idh-icon>
        {{  key() + '.supportBtn' | translate }}
      </button>

    </div>
  </ds-tooltip>
</ng-template>
